import { createFileRoute } from '@tanstack/react-router';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiClient, publicApiQueryClient } from '#src/api.ts';
import { getRequestOnServer } from '#src/functions/getRequestOnServer.ts';
import { OrganizationPage } from '#src/pages/OrganizationPage/index.ts';
import { VenuePage } from '#src/pages/VenuePage/index.ts';
import { ssrWhenNotAuthenticated } from '#src/utils/tanstackRouterUtil.ts';

export const Route = createFileRoute('/{-$locale}/@{$vanityName}')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { locale, vanityName } = params;

    const request = getRequestOnServer();

    const { data: entity } = await publicApiClient.vanityName.get(
      { params: { vanityName } },
      { context: { locale, request } }
    );

    if (entity.entityType === 'organization') {
      const resp = await queryClient.ensureQueryData(
        getReactQueryOptions(
          publicApiQueryClient.organizations.get,
          { params: { id: entity.organizationId } },
          { context: { locale, request } }
        )
      );

      return {
        entityType: 'organization',
        organization: resp.data
      } as const;
    }

    if (entity.entityType === 'venue') {
      const resp = await queryClient.ensureQueryData(
        getReactQueryOptions(
          publicApiQueryClient.venues.get,
          { params: { id: entity.venueId } },
          { context: { locale, request } }
        )
      );

      return {
        entityType: 'venue',
        venue: resp.data
      } as const;
    }

    if (entity.entityType === 'user') {
      return {
        entityType: 'user',
        user: null
      } as const;
    }

    throw new Error('Unknown entity type');
  },
  ssr: ssrWhenNotAuthenticated
});

function RouteComponent() {
  const loaderData = Route.useLoaderData();

  if (loaderData.entityType === 'organization') {
    const { organization } = loaderData;
    return <OrganizationPage organization={organization} />;
  } else if (loaderData.entityType === 'venue') {
    const { venue } = loaderData;
    return <VenuePage venue={venue} />;
  }
}
